import { Component, OnInit } from '@angular/core';
import { FilterChipDto, FiskalniRacuniClient, GetLicenceZaFiskalnuTableQuery, IGetLicenceZaFiskalnuTableQuery, IPaginatedResultOfLpfrLicencaDto, LpfrLicencaDto, PaginatedResultOfLpfrLicencaDto } from '@kodit/core/data-api';
import { ConfigService } from '@kodit/core/services';
import { TableConfig } from '@kodit/core/shared-ui';
import { LazyLoadEvent } from 'primeng/api';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'kodit-licence-fiskalne-table',
  templateUrl: './licence-fiskalne-table.component.html',
  styleUrls: ['./licence-fiskalne-table.component.scss']
})
export class LicenceFiskalneTableComponent implements OnInit {

  private _subs: Subscription = new Subscription();

  /** Configurations */
  paginatedData: IPaginatedResultOfLpfrLicencaDto;
  tableConfig: TableConfig;
  chipItems: FilterChipDto[] = [];
  _skipFirst = 0;
  numberOfRowsDisplayed = 0;

  isLoading = false;
  licenceTable: LpfrLicencaDto[] = [];

  constructor(
    private _configService: ConfigService,
    private _client: FiskalniRacuniClient,
  ) { }

  ngOnInit(): void {
    this.setTableConfig().then();
  }

  private _load(request?: IGetLicenceZaFiskalnuTableQuery) {
      if (!request) {
        request = {
          pageNumber: 0,
          pageSize: 10,
        };
      }

      this.isLoading = true;
      this._subs.add(
        this._client
          .getLicenceForTable(
            request as GetLicenceZaFiskalnuTableQuery
          )
          .pipe(finalize(() => (this.isLoading = false)))
          .subscribe(
            (res: PaginatedResultOfLpfrLicencaDto) => {
              this.licenceTable = res.data;
              this.paginatedData = res;
              this.chipItems = res.activeFilters;
              this._configService.setIsBusy = false;
            },
            (error) => {
              this._configService.setIsBusy = false;
            }
          )
      );
    }

  async setTableConfig(): Promise<void> {
      this.tableConfig = new TableConfig({
        tableHeader: 'Licence',
        isLazy: true,
        lazyCallbackFunction: (event: LazyLoadEvent) => {
          this._skipFirst = event.first;
          this.numberOfRowsDisplayed = event.rows;
          this._load({
            pageNumber: this._skipFirst,
            pageSize: this.numberOfRowsDisplayed,
          } as GetLicenceZaFiskalnuTableQuery);
        },
        columns: [
          {
            header: 'Licenca ID',
            field: 'id',
            type: 'text',
          },
          {
            header: 'Status',
            field: 'statusLicenceDto',
            subField: 'statusStr',
            styleClass: 'status-licence',
            styleClassField: 'statusBadgeStr',
            type: 'badge'
          },
          {
            header: 'Datum važenja',
            field: 'expirationDate',
            type: 'text',
          },
          {
            header: 'Uređaj ID',
            field: 'uredjajId',
            type: 'text',
          },
          {
            field: 'modRadaDto',
            subField: 'modRadaStr',
            header: 'Mod rada',
            styleClass: 'mod-rada-licence',
            styleClassField: 'modRadaBadgeStr',
            type: 'badge',
          },
          {
            header: 'Povezani sertifikati',
            field: 'sertifikatiJID',
            type: 'text',
          },
        ],
      });
    }
}
